import React, { useState, useEffect } from 'react';
import IconButton from '../../../components/Button/iconbutton';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import TableComponent from '../../../components/Table/TableComponent';
import { TableCell, TableRow } from '@mui/material';
import axios from 'axios';
import { BASE_URL, getAxiosConfig } from '../../../components/interface/Config';
import TablePaginationComponent from '../../../components/TablePaginationComponent';
import SearchBar from '../../../components/FormFilelds/PlanSearchBar';
import { apiHandler } from '../../../services/authService';

interface ImagingOrderFormProps {
  patientId: string;
}

interface ImagingOrder {
  id: number;
  scanDate: string;
  scanType: string;
  files: string;
  notes: string;
  link: string;
}

const ImagingOrderForm: React.FC<ImagingOrderFormProps> = ({ patientId }) => {
  const [imagingOrders, setImagingOrders] = useState<ImagingOrder[]>([]);
  const [page, setPage] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [isFileOpen, setIsFileOpen] = useState(false);
  const [fileContent, setFileContent] = useState<string | null>(null); // State for the file content

  const fetchImagingOrders = async () => {
    setLoading(true);
    setError(null);
  
    try {
      const params = {
        limit: rowsPerPage,
        page: page + 1,
        searchkey: searchTerm, // Use searchTerm for filtering
        order_by: 'created_at',
        dir: 2,
        slug: 'imaging',
        user_id: patientId,
        scanOrdersOnly: '',
        scanstatus: '',
      };

      const url        = `${BASE_URL}/resource/docs`;
      const response   = await apiHandler('', 'GET', params, url);

      if (!response) {
          throw new Error("No response received from the server");
      }
  
      // const response = await axios.get(`${BASE_URL}/resource/docs`, {
      //   headers: { ...getAxiosConfig().headers }, // Pass headers properly
      //   params, // Pass query parameters
      // });
  
      const data = response.data.data.docs || [];
      const total = response.data.data.pagination.total;
  console.log('data',data);
      const orders = data.map((item: any) => ({
        id: item.id,
        scanDate: item.addition_info?.date,
        scanType: item.addition_info?.title || 'Unknown',
        files: item.properties?.file_path || 'No file uploaded',
        notes: item.addition_info?.notes || 'No notes',
        link: item.properties?.s3_signed_url || '#',
      }));
  
      setImagingOrders(orders);
      setTotalRecords(total);
    } catch (err) {
      setError('Failed to fetch imaging orders');
    } finally {
      setLoading(false);
    }
  };
  

  useEffect(() => {
    fetchImagingOrders();
  }, [page, rowsPerPage, patientId, searchTerm]); // Re-fetch when searchTerm changes

  const handleFileClick = async (filePath: string) => {
    try {
      const url        = `${BASE_URL}/get-document-url?path=${filePath}`;
      const response   = await apiHandler('', 'GET', {}, url);

      if (!response) {
          throw new Error("No response received from the server");
      }

      // const axiosConfig = getAxiosConfig(); // Retrieve the config
      // const response = await axios.get(
      //   `${BASE_URL}/get-document-url?path=${filePath}`,
      //   { headers: axiosConfig.headers } // Pass headers correctly
      // );
      const fileUrl = response.data.data.url;
      setFileContent(fileUrl);
      setIsFileOpen(true); // Open the file modal
    } catch (err) {
      setError('Failed to fetch the file');
    }
  };
  

  const renderRow = (item: ImagingOrder, index: number) => {
    return (
      <TableRow key={item.id}>
        <TableCell>{index + 1 + page * rowsPerPage}</TableCell>
        <TableCell>{item.scanType}</TableCell>
        <TableCell>
          {item.files !== 'No file uploaded' ? (
            <button
              className="text-blue-500 hover:text-blue-700"
              onClick={() => handleFileClick(item.files)}
            >
              {item.files.split('.').pop()}
            </button>
          ) : (
            <span>{item.files}</span>
          )}
        </TableCell>
        <TableCell>{item.notes}</TableCell>
      </TableRow>
    );
  };

  return (
    <div>
      <div className="flex items-center space-x-4 mb-6 w-full">
        <SearchBar
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          onSearch={() => { fetchImagingOrders().then(() => { }); }}
          onClear={() => setSearchTerm('')}

        />
      </div>


      {loading && <div>Loading...</div>}
      {error && <div className="text-red-500">{error}</div>}

      <TableComponent
        headers={['NO','Scan Type', 'Files', 'Notes']}
        data={imagingOrders}
        renderRow={renderRow}
      />

      <TablePaginationComponent
        count={totalRecords}
        page={page}
        rowsPerPage={rowsPerPage}
        onPageChange={(_event, newPage) => setPage(newPage)}
        onRowsPerPageChange={(event) => {
          const newRowsPerPage = parseInt(event.target.value, 10);
          setRowsPerPage(newRowsPerPage);
          setPage(0); // Reset to first page
        }}
      />

      {/* Modal or iframe for displaying file content */}
      {isFileOpen && fileContent && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white p-4 w-4/5 h-4/5">
            <button
              onClick={() => setIsFileOpen(false)} // Close the modal
              className="text-red-500 font-bold"
            >
              Close
            </button>
            <iframe src={fileContent} className="w-full h-full" />
          </div>
        </div>
      )}
    </div>
  );
};

export default ImagingOrderForm;
